import React from 'react';

import { Box } from '@chakra-ui/react';

interface SpacerProps {
  size?: number;
  mobileSize?: number;
}

const Spacer = ({ size = 0, mobileSize = 0 }: SpacerProps) => {
  return (
    <Box
      height={{
        base: `${mobileSize === 0 ? size : mobileSize}px`,
        md: `${size}px`,
      }}
    />
  );
};

export default Spacer;
